import VidConf from './vidConf';
import JoinRoom from './joinRoom';
import React, {useRef, useEffect} from 'react';
import { selectPeers, 
    selectIsConnectedToRoom,
    useHMSActions,
    useHMSStore } from "@100mslive/react-sdk";

let meetings = require('../seeders/seedMeetings.json');
// let canvas = React.createRef();

const NDAER_URL_NGROK = "https://86a2-2600-1700-6450-4000-e90b-7ad6-121e-da45.ngrok.io/documents"
const NDAER_URL=  "http://localhost:3001/documents"
const Guest_vid ="https://townhall.app.100ms.live/meeting/ymm-jmt-lsr"

//  let el2
function QrModal(props) {
    // const username = props.user   
    const username = props.user//JSON.parse(window.localStorage.getItem('cur_user')) 
    // window.localStorage.setItem('cur_user',JSON.stringify(username))
    // console.log("QRmodal username: ", username)
  function routeHome(){
    window.location.href = `/`
  }
  console.log("process.env.NDAER_URL",process.env.NDAER_URL)
  // }, []);
//   let qrLinkClass = `qr-link hub-button blink-faster`
// function scanTag(){
// let tag 
// if(props.view == 'hub'){tag = 'connect with'}
// else{tag ='enter'}
// return(
//     <>
//         <h4>scan to {tag}:</h4>
//          <h5>{username}</h5>
//     </>
// )
// }
function scanTag(){
let tag 
if(props.view == 'hub'){
    tag = 'connect with'
    return(
        <>
            <h4>scan to {tag}:</h4>
             <h5>{username}</h5>
        </>
    )
}
else  if(props.view === 'meeting'||'event'){
    tag = 'enter'
    return(
        <>
            <h4>scan to {tag}:</h4>
             <h5>{props.tag}</h5>
        </>
    )
}
}
    return (
        <>
        <div className="qr-modal-container">
             <div className="qr-modal-header blink-slower">
                &nbsp;
                <div className="blink" id="QR-share-icon">
                        <img src ='/images/share-nodes-regular.svg' alt="Share QR icon"></img>
                    </div>
             </div>
            <div className='qr-modal-content-wrap'>
                {/* <div className='h-button-wrap'> */}
                <img src = "./images/Townhall_Hub_Local.svg" />
                {/* </div> */}
            </div>
            <div className='qr-modal-footer'>
                
                {scanTag()}
               
            </div>
       
        
      </div>
      </>

  );
}
export default QrModal; 